import { Helmet } from "react-helmet-async";

const SITE_POINT_OF_CONTACT_URL =
  "https://dvagov.sharepoint.com/:x:/r/sites/VHAAmbientAIScribe/Shared%20Documents/General[…]x?d=w4c36023a0d3f4128bd3dd3ba0797255f&csf=1&web=1&e=D6mCwr";

export default function StandaloneUnauthorizedAccount() {
  return (
    <main id="main-content" tabIndex={-1} className="w-[100dvw] min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-gray-100 px-4 py-12 focus:outline-none">
      <Helmet><title>Account Not Yet Activated – Knowtex</title></Helmet>
      <div className="w-full max-w-lg bg-white rounded-xl shadow-lg p-10 text-center">
        <h1 className="text-3xl font-bold text-accent1 mb-5">
          Thanks for Trying Knowtex
        </h1>
        <p className="text-knowtex-grey mb-8">
          Your Microsoft account was authenticated, but your license has not been
          activated yet.
        </p>
        <p className="text-knowtex-grey mb-8">
          If you were directed to this page, your access may still be in progress. Please contact
          your site's designated point of contact. If you do not know
          your site point of contact, review the{" "}
          <a
            href={SITE_POINT_OF_CONTACT_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="underline text-accent2 font-medium"
          >
            site point of contact list
            <span className="sr-only"> (opens in new window)</span>
          </a>
          . If needed, email{" "}
          <a href="mailto:support@knowtex.ai" className="underline text-accent2">
            support@knowtex.ai
          </a>
          {" "}for assistance.
        </p>
        <a
          href="/standalone"
          className="inline-block px-8 py-3 rounded-lg bg-accent2 text-white font-medium hover:bg-accent1"
        >
          Back to Sign-In
        </a>
      </div>
    </main>
  );
}
